import CommonCRUD from "modules/CommonCRUD";

class CitiesAirportsAPI extends CommonCRUD {}

export default CitiesAirportsAPI;
